// extracted by mini-css-extract-plugin
export default {"action":"AvatarEditPopup_action__4ZByJ","actionButton":"AvatarEditPopup_actionButton__W93U1"};